import {ACTION_TYPES, createAction} from "../actions";
import {call, put, takeEvery} from 'redux-saga/effects'
import {createLayer} from "../../http/createLayer";

export function* createLayerSaga () {
    yield takeEvery(ACTION_TYPES.CREATE_LAYER, _createLayer);
}

function* _createLayer (action: any) {
    const patch: {geoType: string, type: string, layername: string, public: boolean} = action.payload;
    try {
        const newLayer = yield call(createLayer, patch);
        yield put(createAction(ACTION_TYPES.CREATE_LAYER_SUCCESS, {...patch, ...newLayer}));
        yield put(createAction(ACTION_TYPES.FETCH_GEOMETRY_LAYER_SUCCESS, {
            data: [], layerType: patch.type
        }));
    } catch (error) {
        yield put(createAction(ACTION_TYPES.CREATE_LAYER_ERROR, {error}));
    }
}
